const getSearchParams = ({ search_type }) => {

  return {
    // availability: 11, // Double check
    per_page: search_type === "map" ? 300 : 100,
    fields: [
      "id",
      "bank",
      "benchmark",
      "property_type",
      "first_year_interest_rate",
      "second_year_interest_rate"
    ],
    order: {
      orderby_custom: [
        "first_year_interest_rate"
      ],
      orderby_isnull_custom: [
        "0"
      ],
      order_custom: [
        "ASC"
      ],
      ordertype_custom: [
        "CHAR"
      ]
    }
  }

}

const getSearchParamsHook = () => {

  const searchParamsHook = (params) => {

    let newParams = { ...params };
    if (params.benchmark) {
      newParams["benchmark[compare=LIKE]"] = params.benchmark;
      delete newParams.benchmark;
    }
    return newParams;

  }

  return searchParamsHook;

}

const getSearchResultsHook = () => {

  const searchResultsHook = async (res) => {
    return res;
  }

  return searchResultsHook;

}

export { getSearchParams, getSearchParamsHook, getSearchResultsHook };
